<template>
  <div class="secondary--text text-h4 font-weight-bold text-capitalize">
    {{ title }}
  </div>
</template>
<script>
export default {
  name: 'AppPageTitle',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    }
  }
}
</script>
